import { render, staticRenderFns } from "./ReturnList.vue?vue&type=template&id=18a60eac&scoped=true&"
import script from "./ReturnList.vue?vue&type=script&lang=js&"
export * from "./ReturnList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnList.vue?vue&type=style&index=0&id=18a60eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a60eac",
  null
  
)

export default component.exports